//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            progressValue: 20
        };
    },

    head() {
      return {
        title: "Decentral-Art How it works",
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: 'Decentral-Art is a browser-based platform for buying a real oil painting, digitized and cut into 10,927 NFT tokens Users can buy virtual plots on the platform'
          }
        ]
      }
    },

    computed: {
        showOverlay() {
            return this.$store.state.token.loading;
        }
    },

    methods: {
        showProgressBar() {
            let interval = setInterval(() => {
                this.progressValue += 20;
                if (this.progressValue >= 100) {
                    clearInterval(interval);
                }
            }, 100);
        },

        goToMainMarket() {
            localStorage.setItem('market', 'buy');
            this.$router.push('/');
        }
    },

    mounted() {
        this.showProgressBar();
    }
};
